// Standard and Pro in the web app. The server decides (backend/app/licensing): these only grey out what it would
// refuse, so a person sees why a control is off instead of meeting a 403. Per the Editions page of the manual: "When a
// feature is outside the current edition, its controls are greyed out and a tooltip names the edition that unlocks it."
import type { Entitlements } from "../api/types";

export const PRO_TIP = "Needs Model Bench Pro. Ask InSiSo to upgrade your organization.";

/** Whether `feature` is open. Unknown (not loaded yet, or an older server) counts as open: the server still checks. */
export const allows = (e: Pick<Entitlements, "features"> | null | undefined, feature: string): boolean =>
  !e || e.features.includes(feature);

/** Props for a control that needs `feature`: disabled with the Pro tooltip when it is closed, else its own tooltip. */
export const gate = (open: boolean, title?: string): { disabled: boolean; title?: string } =>
  open ? { disabled: false, title } : { disabled: true, title: PRO_TIP };

/** "Pro", "Standard", "Pro (trial; then Standard)", or for Pro bought for a period "Pro until 2027-10-10" / "Standard (Pro ended …)". */
export function editionText(o: { edition?: string | null; effective_tier?: string | null; edition_ends_at?: string | null }): string {
  const name = (e?: string | null) => (e === "pro" ? "Pro" : e === "standard" ? "Standard" : "—");
  if (o.effective_tier === "trial") return `Pro (trial; then ${name(o.edition)})`;
  const until = o.edition_ends_at?.slice(0, 10);
  if (o.edition === "pro" && until) return o.effective_tier === "pro" ? `Pro until ${until}` : `Standard (Pro ended ${until})`;
  return name(o.edition);
}
